'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {DisertacijosListSiteCtrl} from "./disertacijoslistsitectrl.js";
EwSiteApp.controller('DisertacijosListSiteCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", DisertacijosListSiteCtrl]);

import {DisertacijosFormCtrl} from "@js/modules/disertacijos/disertacijosform";
EwSiteApp.controller('DisertacijosFormCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", DisertacijosFormCtrl]);